export const inputSuffixTypes = {
  currency: ' €',
  percentage: ' %',
  surfaceArea: ' m²',
  cubicMeter: ' m³',
  energyConsumption: ' kWh/(m²*a)'
};
export const Locales = {
  de: {
    thousandSeparator: '.',
    decimalSeparator: ',',
    zip: '#####',
    suffix: inputSuffixTypes,
    isoCodes: {
      language: 'de-DE',
      currency: 'EUR'
    },
    date: {
      displayFormat: 'TT.MM.JJJJ',
      dateFormat: 'dd.MM.yyyy',
      format: '##.##.####',
      mask: ['T', 'T', 'M', 'M', 'J', 'J', 'J', 'J'],
      days: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So']
    }
  }
};